// Runtime config okuyucu.
//
// Oncelik sirasi:
//   1) window.__APP_CONFIG__  -> container'da envsubst ile doldurulan runtime deger
//   2) process.env.VUE_APP_*  -> local dev / build-time fallback (.env.development)
//
// Not: placeholder henuz doldurulmamissa (deger hala "${...}" ise) build-time
// degerine dusulur. Boylece hem container'da hem `npm run serve`'de dogru calisir.

const runtime = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};

function resolve(runtimeValue, buildValue) {
  if (typeof runtimeValue === 'string' && runtimeValue && !runtimeValue.startsWith('${')) {
    return runtimeValue;
  }
  return buildValue;
}

export const API_BASE_URL = resolve(
  runtime.VUE_APP_API_BASE_URL,
  process.env.VUE_APP_API_BASE_URL,
);

export const APP_VERSION = resolve(
  runtime.VUE_APP_VERSION,
  process.env.VUE_APP_VERSION,
);

// Saha uygulamasinin (cfm-app) yayinlandigi adres. Mobil cihaz esleme ekrani
// karekodu bu adres uzerinden kuruyor. Runtime'da verilmezse build-time
// varsayilani kullanilir (.env.development / .env.production), boylece
// kurulum sihirbazi config.js'i doldururken bu satiri bilmek zorunda degil.
export const MOBILE_APP_URL = resolve(
  runtime.VUE_APP_MOBILE_APP_URL,
  process.env.VUE_APP_MOBILE_APP_URL,
);
